import React from 'react'
import "./home.css"


function Service({icon}) {
    return (
        <>
        <div className="serv_container">
            <div className="icon">
                <img src={icon} alt="checkout"/>
            </div>
            <div className="text_bottom">
                <h5>No Minimum Order</h5>
                <p>Order in for yourself or for free the graph, with no restrictions on order value</p>
            </div>
        </div>
        </>
    )
}

export default Service
